import createSelector from 'lib/createSelector'
import config from 'constants/config'

export const isShowPageViewsEnabled = createSelector(
  (state: App.State) => state.config.experiments[config.SOCIAL_WIDGET_ENABLED_EXPERIMENT_ID],
  (socialSignupABTested) => !!(config.SOCIAL_WIDGET_ENABLED_EXPERIMENT_ID && socialSignupABTested === '1'),
)

export const isShowTotalPurchasesEnabled = createSelector(
  (state: App.State) => state.config.experiments[config.SOCIAL_WIDGET_ENABLED_EXPERIMENT_ID],
  (socialSignupABTested) => !!(config.SOCIAL_WIDGET_ENABLED_EXPERIMENT_ID && socialSignupABTested === '2'),
)
